import { Rutas } from '@/constants/rutas';
import MisterFantasyIcon from '../../icons/MisterFantasyIcon';

export const NavigationMisterFantasyItems = [
    {
        title: 'Mercado Míster',
        shortTitle: 'Mercado Míster',
        path: Rutas.MISTER_FANTASY_MERCADO,
        id: 'mercado-mister-fantasy',
        icon: <MisterFantasyIcon width={20} height={20} />,
    },
    // {
    //     title: 'Puja Ideal Biwenger',
    //     shortTitle: 'Puja',
    //     path: Rutas.PUJA_FANTASY_BIWENGER,
    // },
    // {
    //     title: 'Estadísticas Biwenger',
    //     shortTitle: 'Estadísticas',
    //     path: Rutas.ESTADISTICAS_BIWENGER,
    // },
    {
        title: 'Chollos Fantasy Mister',
        shortTitle: 'Chollos',
        path: Rutas.CHOLLOS_FANTASY_MISTER,
    },
    {
        title: 'Puntuaciones Mister Fantasy',
        shortTitle: 'Puntuaciones',
        path: Rutas.PUNTUACIONES_FANTASY_MISTER,
    },
    {
        title: 'Estadísticas Mister Fantasy',
        shortTitle: 'Estadísticas',
        path: Rutas.ESTADISTICAS_MISTER_FANTASY_ANALYTICS,
        id: 'estadisticas-mister-fantasy',
        icon: <MisterFantasyIcon width={20} height={20} />,
    },
];
